
import I18n from "../../../../commons/I18n/I18n";
import ScreenCard from "../../../../components/screen/ScreenCard";
import { AppIcon } from "../../../../config/Config";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_LAWS } from "../../../../routing/Routes";
import LawListCardCompanyUser from "./LawListCardCompanyUser";

const LawListCompanyUserScreen = () =>(
  <ScreenCard breadcrumbs={[
    {
      name: I18n.tr(I18nKeys.ARTICULOS),
      url: ROUTE_COMPANY_USER_LAWS,
      icon: AppIcon.LAW,
    },
  ]}>
    <LawListCardCompanyUser/>
  </ScreenCard>
);

export default LawListCompanyUserScreen;